import { ref, onScopeDispose } from 'vue'

let lockCount = 0
let savedScrollY = 0
let savedOverflow = ''
let savedHtmlOverflow = ''
let savedPosition = ''
let savedTop = ''
let savedWidth = ''

function applyLock(): void {
  const html = document.documentElement
  const body = document.body
  savedScrollY = window.scrollY
  savedOverflow = body.style.overflow
  savedHtmlOverflow = html.style.overflow
  savedPosition = body.style.position
  savedTop = body.style.top
  savedWidth = body.style.width

  body.style.overflow = 'hidden'
  html.style.overflow = 'hidden'
  body.style.position = 'fixed'
  body.style.top = `-${savedScrollY}px`
  body.style.width = '100%'
}

function releaseLock(): void {
  const html = document.documentElement
  const body = document.body
  body.style.overflow = savedOverflow
  html.style.overflow = savedHtmlOverflow
  body.style.position = savedPosition
  body.style.top = savedTop
  body.style.width = savedWidth
  window.scrollTo(0, savedScrollY)
}

export function acquireScrollLock(): void {
  lockCount++
  if (lockCount === 1) applyLock()
}

export function releaseScrollLock(): void {
  if (lockCount <= 0) return
  lockCount--
  if (lockCount === 0) releaseLock()
}

export function getScrollLockCount(): number {
  return lockCount
}

export function useScrollLock() {
  const isLocked = ref(false)

  function lock() {
    if (!isLocked.value) {
      isLocked.value = true
      acquireScrollLock()
    }
  }

  function unlock() {
    if (isLocked.value) {
      isLocked.value = false
      releaseScrollLock()
    }
  }

  onScopeDispose(() => {
    unlock()
  })

  return { isLocked, lock, unlock }
}
